import {isObject, isString} from 'lodash';
import {jitsuAnalytics} from '@jitsu/js';

export default {
  _getObject() {
    if (isObject(window.config)) {
      return window.config.jitsu;
    } else if (isObject(window.ML)) {
      return window.ML.jitsu;
    }
    return null;
  },
  _getPublicBrowserKey() {
    return this._getObject()?.public_browser_key ?? null;
  },
  _getHost() {
    return this._getObject()?.host ?? null;
  },
  isEnabled() {
    const object = this._getObject();
    return object?.enabled ?? false;
  },
  getAnalytics() {
    if (this.isEnabled() === false) {
      return null;
    }
    return jitsuAnalytics({
      host: this._getHost(),
      writeKey: this._getPublicBrowserKey(),
    })
  },
  /**
   * @see https://getanalytics.io/api/#analyticsuser
   * @returns {*}
   */
  user() {
    if (this.isEnabled() === false) {
      return null;
    }
    return this.getAnalytics()?.user();
  },
  /**
   * @see https://getanalytics.io/api/#analyticspage
   */
  page() {
    if (this.isEnabled() === false) {
      return;
    }
    //console.log('Jitsu Page');
    try {
      this.getAnalytics()?.page();
    } catch (e) {
    }
  },
  /**
   * @see https://getanalytics.io/api/#analyticsidentify
   * @param user
   */
  identify(user) {
    if (this.isEnabled() === false) {
      return;
    }
    if (isObject(user) && isString(user.email)) {
      //console.log('Jitsu Identify', user.email);
      try {
        this.getAnalytics()?.identify(user.email, {
          id: user.id,
          email: user.email,
          name: user.name,
          team_id: user.current_team_id,
        });
      } catch (e) {
      }
    }
  },
  /**
   * @see https://getanalytics.io/api/#analyticstrack
   * @param eventName String
   * @param payload (optional) Object - Event payload
   * @param options (optional) Object - Event options
   * @param callback (optional) Function - Callback to fire after tracking completes.
   */
  track(eventName, payload = {}, options = {}, callback = null) {
    if (this.isEnabled() === false) {
      return;
    }
    try {
      this.getAnalytics()?.track(eventName, payload, options, callback)
    } catch (e) {
    }
  }
}
